export const getInitialState = () => ({
  urlValue: "",
  group: null,
  // users: [],
  selectedUser: null,
  reloading: false,
  // educations: [],
  selectedEducation: null,
});

export const getInitialFormState = () => ({
  id: 0,
  name: "",
  title: "",
  status: 0,
  description: "",
  users: [],
  url: "",
  body: "",
  category: "",
  region: "",
  logo: [],
  logo2: [],
  logo3: [],
  location: null,
  contacts: [],
  parentGroups: [],
  // parentGroupId: "",
  employer_type: [],
  docs: "",
  website: "",
  certified: null,
  decertified: null,
  educator_type: [],
  educator_category: [],
  vopage: false,
  images: [],
  front_title: "",
  data_protection_policy_url: "",
  front_body: "",
  educations: [],
});
